const getCustomerId = (customer) =>
  customer && typeof customer === 'object' ? customer.id : customer;

const getAssignedSubjects = (survey) =>
  String(survey?.assignedSubjects || '')
    .split(',')
    .map((subject) => subject.trim())
    .filter(Boolean);

export const isSurveyApplicableToCustomer = (survey, customer) => {
  if (survey?.subject !== 'D') return true;

  const customerId = getCustomerId(customer);
  if (!customerId) return false;

  const assignedSubjects = getAssignedSubjects(survey);
  if (assignedSubjects.length === 0) return true;

  return assignedSubjects.some((subject) => subject === String(customerId));
};
